import { Box, useTheme } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import '../../Optimizations/OptimizationFields.css'

const DatePickerEditMode = ({ open, setOpen, label, value, onChange, isEditMode }) => {
  const theme = useTheme()
  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }
  const textFieldStyles = {
    //@ts-ignore
    '& .Mui-disabled': { color: theme.palette.text.primary },
    '& .MuiInputBase-input': {
      //@ts-ignore
      color: theme.palette.text.primary,
      //@ts-ignore
      WebkitTextFillColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,1)' : 'rgba(0,0,0,1)',
      '--color': theme.palette.mode === 'dark' ? 'rgba(255,255,255,1)' : 'rgba(0,0,0,1)',
    },
    '& .MuiInputBase-root.Mui-disabled': {
      //@ts-ignore
      color: theme.palette.text.primary,
      bgcolor: 'background.defaultdim',
    },
  }
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
        }}
        onClick={handleOpen} // Open DatePicker on click
      >
        <DatePicker
          open={open}
          label={label ?? ''}
          onOpen={handleOpen}
          onClose={handleClose}
          value={value ? dayjs(value) : null}
          onChange={newValue => {
            setOpen(false)
            onChange(newValue)
          }}
          slotProps={{
            textField: {
              variant: 'outlined',
              disabled: !isEditMode,
              sx: {
                width: '100%',
                ...textFieldStyles,
              },
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  )
}

export default DatePickerEditMode
